import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ServicioEnviarMailModel } from 'src/app/models/servicioEnviarMail.Model';
import { ContactoViaMailService } from 'src/app/servicios/publicos/contacto-via-mail.service';
import Swal from 'sweetalert2';
//import Swal from 'sweetalert';
import { ConsultaPublicaColeModel } from './../../../models/consultaPublicaCole.Model';

@Component({
  selector: 'app-pantalla-contacto',
  templateUrl: './pantalla-contacto.component.html'
})
export class PantallaContactoComponent implements OnInit {

  consulta: ConsultaPublicaColeModel;
  _ocultarMensajeError: boolean;

  constructor(private router: Router, private _contactoViaMailService: ContactoViaMailService) { }

  ngOnInit() {
    this.consulta = new ConsultaPublicaColeModel();
    console.log(this.consulta );
  }

  enviarMailConsultaForm(form: NgForm ) {
    if ( form.invalid ) { 
      this._ocultarMensajeError = true;
      return; 
    }
    this._ocultarMensajeError = false;    
    console.log(form);

    this.consulta.nombre = form.value.nombre;
    this.consulta.apellido = form.value.apellido;
    this.consulta.telefono = form.value.telefono;
    this.consulta.mail = form.value.email;
    this.consulta.mensaje = form.value.mensaje;
    console.log(this.consulta );

    let respServicioEnviarMailModel: ServicioEnviarMailModel = new ServicioEnviarMailModel();

    //console.log('0');
    this._contactoViaMailService.enviarMailContactoPublico( this.consulta )
      .subscribe( resp => {
        console.log(resp);
        respServicioEnviarMailModel = resp;
        console.log('respServicioEnviarMailModel.codigo: ' + respServicioEnviarMailModel.codigo);
        Swal.close();
        //console.log('1');
        if(respServicioEnviarMailModel.codigo.valueOf() == '200'){
          ///console.log('IF');
          Swal.fire({
            title: 'La consulta se envio exitosamente!',
            icon: 'success',
            showConfirmButton: true
          });
          this.router.navigateByUrl('/pantallaPrincipal');
        }else{
          Swal.fire({
            title: 'Error al enviar!',
            text: 'No se ha podido enviar la consulta, por favor vuelva a intentarlo',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
          console.log('ELSE');
        }    
       // console.log('2');
        // this.router.navigateByUrl('/pantallaPrincipal');
      }, (err) => {
        console.log(err.error.error.message);
        Swal.fire({
          title: 'Error al autenticar',
          text: err.error.error.message
        });
      Swal.close();
    });
    //console.log('3');
  }
}
